<template>
    <div class="grouppatrimonial">
        <PageTitle icon="fa fa-clone" main="Registro" sub="Grupo Patrimonial" />
         <b-form  v-show="mode === 'save' || mode === 'remove' || mode === 'read'">
             <input 
                id="grouppatrimonial-id" 
                type="hidden" 
                v-model="grouppatrimonial.id" />
             <b-row>
                <b-col md="9" sm="12">
                  <b-form-group 
                      label="Descrição:" 
                      label-for="grouppatrimonial-group_patrimonial_name">
                      <b-form-input 
                          id="grouppatrimonial-group_patrimonial_name" 
                          type="text"
                          v-model="grouppatrimonial.group_patrimonial_name" 
                          size="sm"
                          ref="focusadd"
                          :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                          placeholder="Nome..." />
                  </b-form-group>
                </b-col>    
                <b-col md="3" sm="12">    
                  <b-form-group 
                        label="% Depreciação (Anual):" 
                        label-for="grouppatrimonial-depreciation_yearly">
                      <b-form-input id="grouppatrimonial-depreciation_yearly" 
                          v-model="grouppatrimonial.depreciation_yearly" 
                          type="number"
                          size="sm"
                          step="0.02"
                          pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                          />
                  </b-form-group>
                </b-col>
             </b-row>
         </b-form>
              <hr v-show="mode === 'save'">
              <b-row>
                <b-col xs="12" class="sub-background">
                   <b-button  
                        size="sm" 
                        variant="light" 
                        class="mt-2  mb-2 fa fa-plus" 
                        v-show="mode !== 'save' && mode !== 'remove'"
                        @click="alterModo">
                    </b-button>
                    <b-button 
                         
                        size="sm" 
                        variant="light"
                        class="mt-2 mb-2 ml-2 fa fa-save" 
                        v-if="mode === 'save'"
                        @click="save">
                        </b-button>
                    <b-button 
                         
                        size="sm" 
                        variant="light" 
                        class="mt-2 mb-2 ml-2 fa fa-trash" 
                        v-if="mode === 'remove'"
                        @click="remove">
                        </b-button>
                    <b-button 
                        size="sm" 
                        btn-sm 
                        variant="light" 
                        class="mt-2 mb-2 ml-2 fa fa-ban"  
                        v-if="mode === 'remove' || mode === 'save' || mode === 'read' "
                        @click="reset">
                    </b-button>
                    <b-button 
                         size="sm" 
                         class="mt-2 mb-2 ml-2 fa" 
                         :class="icon" 
                         @click="[loadGroupPatrimonials(),toggleBusy(),showTable = !showTable]" 
                         variant="light" >
                    </b-button>
                </b-col>
            </b-row>
            <br>
           <div class="col-sm-4">
                    <div class="form-group">
                        <input 

                            type="text" 
                            size="sm" 
                            icon="search" 
                            v-model="search" 
                            ref="searchFocus"
                              v-show="mode !== 'save' && mode !== 'remove'"
                            placeholder="Informe a descrição" 
                            class="form-control">
                    </div>
                </div>

                <b-row>
                     <b-col md="6" sm="12" >   
                        <transition  name="slide" type="animation" appear>       
                            <b-table 
                                 :busy="isBusy" 
                                class="table-responsive"  
                                v-show="showTable" 
                                hover 
                                key="slide" 
                                 head-variant="light" 
                                :per-page="perPage" 
                                :current-page="currentPage" 
                                :items="filteredList" 
                                :fields="fields">
                                <template v-slot:table-busy>
                                    <div class="text-center text-info my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>Carregando...</strong>
                                    </div>
                                </template>
                                <template v-slot:cell(actions)="data">
                                        <b-button  
                                             
                                            title = "Detalhe do registro" 
                                            size="sm" 
                                            variant="light" 
                                            @click="loadGroupPatrimonial(data.item, 'read')" 
                                            class="mr-2 mt-2">
                                            <i class="fa fa-drivers-license-o"></i>
                                        </b-button>
                                        <b-button  
                                             title = "Editar registro" 
                                            size="sm" 
                                            variant="light" 
                                            @click="loadGroupPatrimonial(data.item)" 
                                            class="mr-2 mt-2">
                                            <i class="fa fa-pencil"></i>
                                        </b-button>
                                        <b-button  
                                             
                                            title = "Excluir registro" 
                                            size="sm" 
                                            variant="light" 
                                            @click="loadGroupPatrimonial(data.item, 'remove')" 
                                            class="mr-2 mt-2">
                                            <i class="fa fa-trash"></i>
                                        </b-button>
                                        <b-button  
                                              
                                            v-b-modal.modalSubGroup 
                                            title = "Adicionar Sub. Grupo Patrimonial" 
                                            size="sm" 
                                            variant="light" 
                                            @click="actionNewSubGroup(data.item)" 
                                            class="mr-2 mt-2">
                                                <i class="fa fa-plus"></i>
                                        </b-button>
                                        <b-button 
                                             
                                            title = "Listar Sub. Grupo Patrimonial" 
                                            size="sm" 
                                            variant="light" 
                                            @click="setSubGroup(data.item)" 
                                            class="mr-2 mt-2">
                                            <i class="fa fa-tasks"></i>
                                        </b-button> 
                                    </template>   
                            </b-table>    
                        </transition>
                         <transition  name="slide" type="animation" appear>
                         <b-pagination
                             v-show="showTable"
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                            size="sm"
                            aria-controls="my-table"
                        ></b-pagination>
                         </transition>
                    </b-col>
                     <b-col  md="6" sm="12" >   
                        <transition  
                            name="slide" 
                            type="animation" 
                            appear>       
                            <b-table 
                                class="table-responsive"  
                                v-show="showTableSubGroup" 
                                hover key="slide" 
                                 head-variant="light" 
                                :items="grouppatrimonialsubgroups" 
                                :fields="fieldsSubGroup">
                                <template v-slot:cell(actions)="data">
                                        <b-button   
                                            v-b-modal.modalSubGroup 
                                            title = "Editar registro" 
                                            size="sm" 
                                            variant="light" 
                                            @click="loadGroupPatrimonialSubGroup(data.item)" class="mr-2 mt-2">
                                            <i class="fa fa-pencil"></i>
                                        </b-button>
                                        <b-button   
                                            size="sm" 
                                            variant="light" 
                                            @click="modeSubGroup = 'remove'" 
                                            class="mr-2 mt-2"
                                            v-if="modeSubGroup === 'insert'">
                                            <i class="fa fa-trash"></i>
                                        </b-button>
                                        <b-button   
                                            size="sm" 
                                            variant="light" 
                                            @click="[removeSubGroup(data.item),modeSubGroup = 'insert']" 
                                            class="mr-2 mt-2"
                                            v-if="modeSubGroup === 'remove'"
                                        >
                                            <i class="fa fa-check"></i>
                                        </b-button>
                                        <b-button   
                                            size="sm" 
                                            variant="light"
                                            @click="modeSubGroup = 'insert'" 
                                            class="mr-2 mt-2"
                                            v-if="modeSubGroup === 'remove'"
                                        >
                                            <i class="fa fa-times"></i>
                                        </b-button>
                                        <span 
                                            class="mr-2 mt-2"  
                                            v-if="modeSubGroup === 'remove'" >Deseja Excluir o registro?</span>
                                                        
                                </template>   
                            </b-table>    
                        </transition>
                    </b-col>
                </b-row>   

        <b-modal id="modalSubGroup"
            ref="modal"
            title-tag = "h6"
            size="lg"
            title="Sub.Grupo Patrimonial"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveSubGroup"
            >
           <b-form>
               <b-row>
                <b-col md="9" sm="12">
                  <b-form-group 
                      label="Descrição:" 
                      label-for="grouppatrimonialsubgroup-sub_group_patrimonial_name">
                      <b-form-input 
                          id="grouppatrimonialsubgroup-sub_group_patrimonial_name" 
                          type="text"
                          v-model="grouppatrimonialsubgroup.sub_group_patrimonial_name" 
                          size="sm"
                          ref="focusadd"
                          
                          placeholder="Nome..." />
                  </b-form-group>
                </b-col>    
                <b-col md="3" sm="12">    
                  <b-form-group 
                        label="% Depreciação (Anual):" 
                        label-for="grouppatrimonialsubgroup-sub_depreciation_yearly">
                      <b-form-input id="grouppatrimonialsubgroup-sub_depreciation_yearly" 
                          v-model="grouppatrimonialsubgroup.sub_depreciation_yearly" 
                          type="number"
                          size="sm"
                          step="0.02"
                          pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                          />
                  </b-form-group>
                </b-col>
             </b-row>
           </b-form>
        </b-modal>
    </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'

export default {
    name: 'GroupPatrimonial',
    components: {PageTitle},
    data: function() {
        return {
            mode: 'insert',
            modeSubGroup: 'insert',
            search: '',
            grouppatrimonial: {},
            grouppatrimonials: [],
            grouppatrimonialsubgroup: {},
            grouppatrimonialsubgroups: [],
            showTable: false,
            showTableSubGroup: false,
            perPage: 5,
            currentPage: 1,
            headerBgVariant: 'dark',
            headerTextVariant: 'light',
            bodyBgVariant: 'light',
            bodyTextVariant: 'dark',
            footerBgVariant: 'warning',
            footerTextVariant: 'dark',
            fields: [
                { key: 'group_patrimonial_name', label: 'Descrição', sortable: true },
                { key: 'depreciation_yearly', label: '% Depreciação (Anual)', sortable: true },          
                { key: 'actions', label: 'Ações', variant: 'light' }
            ],
            fieldsSubGroup: [
                { key: 'sub_group_patrimonial_name', label: 'Sub. Descrição', sortable: true },
                { key: 'sub_depreciation_yearly', label: '% Depreciação (Anual)', sortable: true },                         
                { key: 'actions', label: 'Ações', variant: 'light' }
            ]
        }
    },
     computed:
        {  
        user(){
            return this.$store.state.user
        },
        filteredList() {
            return this.grouppatrimonials.filter(grouppatrimonial => {
            return grouppatrimonial.group_patrimonial_name.toLowerCase().includes(this.search.toLowerCase())
                })
        },
        icon() {
            return this.showTable ? "fa-retweet" : "fa-search"
        },
        rows() {
            return this.grouppatrimonials.length
        },
    },
    methods: {
        async loadGroupPatrimonials() {
            const url = `${baseApiUrl}/grouppatrimonials`
            await axios.get(url).then(res => {
                this.grouppatrimonials = res.data
                  this.isBusy = false
            })
        },
        async loadGroupPatrimonialSubGroups() {
            const url = `${baseApiUrl}/grouppatrimonialsubgroups/${this.grouppatrimonial.id}/grouppatrimonial`
            await axios.get(url).then(res => {
                this.grouppatrimonialsubgroups = res.data
            })
        },
        async reset() {
            this.mode = 'insert'
            await this.loadGroupPatrimonials()
            this.grouppatrimonialsubgroups = []
        },
         toggleBusy() {
          this.isBusy = !this.isBusy
         },
        alterModo() {
                    this.mode = 'save'
                    this.grouppatrimonial = {}      
            }, 
        async save() {
            const method = this.grouppatrimonial.id ? 'put' : 'post'
            const id = this.grouppatrimonial.id ? `/${this.grouppatrimonial.id}` : ''
            this.grouppatrimonial.user_id = this.user.id
            await axios[method](`${baseApiUrl}/grouppatrimonials${id}`, this.grouppatrimonial)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
        },
        async saveSubGroup() {
            const method = this.grouppatrimonialsubgroup.id ? 'put' : 'post'
            const id = this.grouppatrimonialsubgroup.id ? `/${this.grouppatrimonialsubgroup.id}` : ''

            this.grouppatrimonialsubgroup.user_id = this.user.id
            this.grouppatrimonialsubgroup.group_patrimonial_id = this.grouppatrimonial.id
            await axios[method](`${baseApiUrl}/grouppatrimonialsubgroups${id}`, this.grouppatrimonialsubgroup)
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    await this.loadGroupPatrimonialSubGroups()
                })
                .catch(showError)
        },
        async remove() {
            const id = this.grouppatrimonial.id
            await axios.delete(`${baseApiUrl}/grouppatrimonials/${id}`)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
        },
       async removeSubGroup(groupsub) {
            const id = groupsub.id
            await axios.delete(`${baseApiUrl}/grouppatrimonialsubgroups/${id}`)
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    await this.loadGroupPatrimonialSubGroups()
                })
                .catch(showError)
        },
        loadGroupPatrimonial(grouppatrimonial, mode = 'save') {
            this.mode = mode
            this.grouppatrimonial = { ...grouppatrimonial }

        },
        loadGroupPatrimonialSubGroup(grouppatrimonialsubgroup) {
            this.grouppatrimonialsubgroup = { ...grouppatrimonialsubgroup }
        },
       async actionNewSubGroup(grouppatrimonial){
            this.grouppatrimonial = { ...grouppatrimonial }
            this.grouppatrimonialsubgroup = {}
            await this.loadGroupPatrimonialSubGroups()
            this.showTableSubGroup = true
        },
        async setSubGroup(grouppatrimonial){
            this.grouppatrimonial = { ...grouppatrimonial }
            this.grouppatrimonialsubgroup = {}
            await this.loadGroupPatrimonialSubGroups()
            this.showTableSubGroup = true
        },
        focusAdd(){
            this.$refs.focusadd.focus()
        },
        focusSearch(){
            this.$refs.inputsearch.focus()
        },
    },
   async mounted() {
       await this.loadGroupPatrimonials()
        this.showTable = true
    }
}
</script>

<style>

    .sub-background{
      background:linear-gradient(to top, #bdc3c7, #e7ebee);
      border-radius: 35px ;
    }


     .grouppatrimonial {
        font-size: 0.7rem;
    }


    .grouppatrimonial input,label,form{
        font-size: 0.7rem;
    }
    .grouppatrimonial button{
        font-size: 0.7rem;
    }

    .grouppatrimonial select{
        font-size: 0.7rem;
    }

    .grouppatrimonial table{
        font-size: 0.7rem;
    }

     #modalSubGroup {
        font-size: 0.7rem;
    }

    #modalSubGroup input{
        font-size: 0.7rem;
    }

    #modalSubGroup button{
        font-size: 0.7rem;
    }

    @keyframes slide-in {
    from {transform: translateY(40px);}
    to {transform: translateY(0);}
    }

    @keyframes slide-out {
        from {transform: translateY(0);}
        to {transform: translateY(40px);}
    }

    .slide-enter-active {
    animation: slide-in 1s ease;
        transition: opacity 1s;
    }

    .slide-leave-active {
        animation: slide-out 1s ease;
        transition: opacity 1s;
    }

    .slide-enter, .slide-leave-to{
        opacity: 0;
    }

    .fade-enter, .fade-leave-to{
    opacity: 0;
    }

    .fade-enter-active, .fade-leave-active{
    transition: opacity 1s;
    }

</style>
